var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4194 12.6677C15.4725 12.5039 15.5 12.3714 15.5 12.2708V1.98641C15.5 1.90641 15.4725 1.85828 15.4194 1.84203C15.3663 1.82578 15.3 1.81703 15.2206 1.81703H10.1956V2.74391H11.6769V4.21141H10.1956V4.67891H11.6769V6.14828H10.1956V6.62891H11.6769V8.01828H10.1956V8.57516H11.6769V9.96766H10.1956V10.5245H11.6769V11.9252H10.1956V12.947H15.2206C15.3 12.9227 15.3663 12.8295 15.4194 12.6677ZM14.5688 11.9239H12.1581V10.5245H14.5688V11.9239ZM14.5688 9.96766H12.1581V8.57453H14.5688V9.96766ZM14.5688 8.01766H12.1581V6.63453H14.5688V8.01766ZM14.5688 6.14766H12.1581V4.68016H14.5688V6.14766ZM14.5688 4.20328H12.1581V2.74516H14.5688V4.20328ZM9.35 0.0195312L0.5 1.58516V13.1802L9.35 14.707V0.0195312ZM5.74562 10.3564C5.71187 10.2652 5.55312 9.87891 5.27188 9.19516C4.99125 8.51203 4.82188 8.11453 4.7725 8.00078H4.75688L3.8075 10.2539L2.53875 10.1683L4.04375 7.36328L2.66562 4.55891L3.95937 4.49078L4.81437 6.68578H4.83125L5.79688 4.39141L7.13375 4.30703L5.54188 7.34266L7.1825 10.4395L5.74562 10.3564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.6c831c9ac8bcf594003b1f68d6d3ab8c.svg";
export { ForwardRef as ReactComponent };